export default __webpack_public_path__ + "static/media/cfx-cm-best-practice.3fd616ec.svg";